import React from "react";
import { Link } from "react-router-dom";
import { FaMapMarkerAlt, FaEnvelope } from "react-icons/fa";
import contentConfig from "../content.config.json";
import "../Styles/Footer.css";

const Footer = () => {
  const { brand, legalName, tagline, locations } = contentConfig.footer;

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-top">
          <div className="footer-brand">
            <Link to="/" className="footer-brand-link">
              <img
                src="/images/logo-mark-light.png"
                alt={brand}
                className="footer-logo"
              />
              <span className="footer-wordmark">{brand}</span>
            </Link>
            <p className="footer-tagline">{tagline}</p>
          </div>

          <nav className="footer-nav" aria-label="Footer">
            <Link to="/">Home</Link>
            <Link to="/services">Services</Link>
            <Link to="/projects">Projects</Link>
            <Link to="/contact">Contact</Link>
          </nav>
        </div>

        <div className="footer-meta">
          <div className="footer-meta-block">
            <h3 className="footer-heading">
              <FaMapMarkerAlt /> Locations
            </h3>
            <ul className="footer-locations">
              {locations.map((location, index) => (
                <li key={index}>
                  <span className="footer-location-city">{location.city}</span>
                  <span className="footer-location-state">{location.state}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="footer-meta-block footer-meta-block--right">
            <h3 className="footer-heading">
              <FaEnvelope /> Contact
            </h3>
            <a
              href="mailto:admin@pipbros.com"
              className="footer-contact"
            >
              admin@pipbros.com
            </a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="footer-bottom-inner">
          <p>
            &copy; {new Date().getFullYear()} {legalName}. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
